import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, TEL_HREF } from "@/siteConfig";

export const CallBand = ({ id, title, text }) => (
  <section
    data-testid={`${id}-call-band`}
    className="border-y border-amber-400/15 bg-gradient-to-r from-amber-400/[0.08] via-[#0D1119] to-amber-400/[0.05] py-12 sm:py-14"
  >
    <Reveal className="mx-auto flex max-w-4xl flex-col items-center gap-5 px-4 text-center sm:px-6">
      <p className="font-display text-xl sm:text-2xl font-bold tracking-tight text-zinc-100">
        {title}
      </p>
      <p className="max-w-xl text-sm sm:text-base leading-relaxed text-zinc-400">
        {text}
      </p>
      <a
        href={TEL_HREF}
        data-testid={`${id}-call-now-button`}
        className="group inline-flex items-center gap-3 rounded-full bg-amber-400 px-9 py-4 text-base font-extrabold uppercase tracking-wide text-zinc-950 transition-all hover:bg-amber-300 hover:shadow-[0_0_44px_rgba(245,158,11,0.45)] active:scale-[0.98]"
      >
        <Phone className="h-5 w-5 transition-transform group-hover:rotate-12" />
        Chiama ora — {SITE.phoneDisplay}
      </a>
    </Reveal>
  </section>
);
